import { render, staticRenderFns } from "./newsTpl.vue?vue&type=template&id=eef23ea8&"
import script from "./newsTpl.vue?vue&type=script&lang=js&"
export * from "./newsTpl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports